import React from 'react';
import Input from '../../../components/ui/Input';

const EmpresaTab = ({ form, onChange }) => {
  const handleChange = (field) => (e) => {
    onChange(field, e?.target?.value);
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-base font-semibold text-foreground mb-4">Información del negocio</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Nombre comercial"
            value={form?.business_name || ''}
            onChange={handleChange('business_name')}
            placeholder="Ej. Verdi Llantas"
          />
          <Input
            label="Nombre fiscal"
            value={form?.fiscal_name || ''}
            onChange={handleChange('fiscal_name')}
            placeholder="Nombre completo o razón social"
          />
          <Input
            label="RFC"
            value={form?.rfc || ''}
            onChange={handleChange('rfc')}
            placeholder="Ej. VERM690901CD6"
            className="uppercase"
          />
          <Input
            label="Dirección"
            value={form?.address || ''}
            onChange={handleChange('address')}
            placeholder="Calle, número, colonia"
          />
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-foreground mb-4">Datos de contacto</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="WhatsApp"
            value={form?.whatsapp || ''}
            onChange={handleChange('whatsapp')}
            placeholder="Ej. 2293698695"
            type="tel"
          />
          <Input
            label="Teléfono"
            value={form?.phone || ''}
            onChange={handleChange('phone')}
            placeholder="Número de teléfono"
            type="tel"
          />
          <Input
            label="Correo electrónico"
            value={form?.email || ''}
            onChange={handleChange('email')}
            placeholder="correo@empresa.com"
            type="email"
          />
          <Input
            label="Sitio web"
            value={form?.website || ''}
            onChange={handleChange('website')}
            placeholder="www.empresa.com"
          />
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-foreground mb-4">Redes sociales</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Facebook (usuario)"
            value={form?.facebook_name || ''}
            onChange={handleChange('facebook_name')}
            placeholder="Ej. verdi_llantas"
          />
          <Input
            label="Instagram (usuario)"
            value={form?.instagram_name || ''}
            onChange={handleChange('instagram_name')}
            placeholder="Ej. verdi_llantas"
          />
          <Input
            label="URL de Facebook"
            value={form?.facebook_url || ''}
            onChange={handleChange('facebook_url')}
            placeholder="https://www.facebook.com/..."
          />
          <Input
            label="URL de Instagram"
            value={form?.instagram_url || ''}
            onChange={handleChange('instagram_url')}
            placeholder="https://www.instagram.com/..."
          />
        </div>
      </div>
    </div>
  );
};

export default EmpresaTab;
